

exports.__esModule = true;

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _app = require('xo-models/src/app');

var _auth = require('xo-models/src/auth');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _sharedUtil = require('../services/shared-util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCIPVerificationPageDirective', {
    tag: 'xo-cip-verification',
    template: _template2['default'],

    resolve: {
        models: function models() {
            return {
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
                auth: _auth.$AuthModel.instance().retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            $('#outerWrapper').addClass('tokenization');
        },
        populate: function populate() {
            var tokenizedWalletInfoModel = this.models.tokenizedWalletInfoModel;

            var cfpbInfoContent4Key = _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale) ? 'topup.cfpb.info.content4PPBalance' : 'topup.cfpb.info.content4';

            // fpti logging
            _logger.$logger.info('checkout_fpti', {
                from: 'CIP_VERIFICATION',
                to: 'prepare_cip_verification',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token'
            });

            // content about the disclaimer
            this.showModal = true;
            this.brandName = tokenizedWalletInfoModel.brandName();
            this.cfpbHeading1 = (0, _squid.$renderContent)('topup.cfpb.commonHeading1');
            this.cfpbHeading2 = (0, _squid.$renderContent)('topup.cfpb.commonHeading2', { type: this.brandName });
            this.cfpbInfoContent1 = (0, _squid.$renderContent)('topup.cfpb.info.content1');
            this.cfpbInfoContent2 = (0, _squid.$renderContent)('topup.cfpb.info.content2', { type: this.brandName });
            this.cfpbInfoContent3 = (0, _squid.$renderContent)('topup.cfpb.info.content3');
            this.cfpbInfoContent4 = (0, _squid.$renderContent)(cfpbInfoContent4Key);
        },
        exit: function exit() {
            // fpti logging
            _logger.$logger.info('checkout_fpti', {
                from: 'CIP_VERIFICATION',
                to: 'redirect_cip_verification',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token'
            });
        }
    },

    actions: {
        submit: function submit() {
            // if buyer auth is not remembered
            if (this.models.auth.remembered === false) {
                var configUrls = _squid.$config.urls;
                var tokenizedWalletInfoModel = this.models.tokenizedWalletInfoModel;

                // we need pass hermes url as return URL to CFPB provision flow
                // this is getting used by CFPB flow to redirect back after successful CFBP provisioning

                var baseUrl = configUrls.baseUrl;
                var params = {
                    token: _squid.$meta.token,
                    ba_token: _squid.$meta.baToken,
                    jwt: _squid.$meta.query.jwt
                };
                var PPBalanceFlowParams = '';

                if (_sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale)) {
                    var appName = tokenizedWalletInfoModel.isAndroidPay() ? 'Google_app' : 'Samsung_app';

                    PPBalanceFlowParams = '&capability=reload&entryPoint=' + appName + '&intent=starpay';
                }

                var returnUrl = encodeURIComponent(_squid.$util.buildURL(baseUrl, params));

                this.redirectURL = _squid.$util.buildURL(configUrls.cipAgreementUrl) + '?successUrl=' + returnUrl + PPBalanceFlowParams;
                _logger.$logger.info('CIP_REDIRECTION_URL', { url: this.redirectURL });
                _squid.$util.redirect(this.redirectURL);
            } else {
                // if buyer is not loggedIn using credentials, then auth is remembered
                // redirect to UL as riskyLogin for this usecase
                this.models.auth.redirectToLogin('insufficientPermission', { ulClientKey: 'cipVerification' });
            }
        }
    }
});


_angular.$rootScope;

_logger.$logger;

_squid.$Component;

_squid.$locale;

_squid.$renderContent;

_squid.$config;

_squid.$util;

_squid.$meta;

_app.$TokenizedWalletInfoModel;

_auth.$AuthModel;

_sharedUtil.$SharedUtil;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-cip-verification/directive.js
// module id = ./pages/xo-cip-verification/directive.js
// module chunks = 0